"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
exports.MainHeader = function MainHeader(props) {
    return (React.createElement(StyledMainHeader, { className: props.className, title: props.title },
        props.image,
        props.title && React.createElement(StyledTitle, null, props.title)));
};
const StyledMainHeader = styled_components_1.default.div `
  width: 100%;
  height: auto;
  color: ${props => props.theme.colors.color};
  ${props => !props.image &&
    `
      display: flex;
      padding: 10px 15px;
      color: ${props.theme.active};
      align-items: center;
      justify-content: center;
    `};
`;
const StyledTitle = styled_components_1.default.span `
  font-family: ${props => props.theme.fonts.default};
`;
//# sourceMappingURL=main-header.js.map